<elcia-dropdown
  [control]="control()"
  [items]="this.items()"
  [label]="'entity.country' | translate" class="flex">
  <ng-template #item let-item>
    <div class="flex">

      @if (item.imageUrl) {
        <img alt="icon-country" class="mr-3 rounded-full object-cover" height="20" ngSrc="{{item.imageUrl}}" width="20">
      }
      <span>{{ item.name }}</span>
    </div>
  </ng-template>
</elcia-dropdown>
